import * as types from '../constants/ActionTypes'
import api from '../utils/api'
import config from '../config'


let getDepartmentsInitiate = () => {
	return {
		type: types.GET_DEPARTMENTS,
		payload: {}
	}
}

let getDepartments = (companyId) => {
	return (dispatch, getState) => {
		if (companyId!==config.companyId){
            return
		}
		var url = '/' + companyId + '/departments'
		dispatch(getDepartmentsInitiate())
		return api(url).get()
			.then(departments => {
				if(departments.errCode==0){
                    departments.result.shift();
                    dispatch(getDepartmentsFinish(departments));
				}else{
                    dispatch(getDepartmentsFinish({errCode:-1}))
				}
			})
			.catch(err => {
				dispatch(getDepartmentsFinish({errCode:-1}))
			})
	}
}

let getDepartmentsFinish = (departments) => {
	if (departments.errCode == 0) {
		return {
			type: types.GET_DEPARTMENTS_FINISH,
			payload: {
				departments:departments.result
			}
		}
	} else {
		return {
			type: types.GET_DEPARTMENTS_FINISH,
			payload: {},
			error: true
		}
	}
}

export default {getDepartments}
